import { NgModule } from '@angular/core';
import { AccountSettingsV2Component } from './account-settings-v2.component';

@NgModule({
    imports: [AccountSettingsV2Component],
    exports: [AccountSettingsV2Component],
})
export class AccountSettingsModule {}
